<h2 mat-dialog-title class="nta-dialog-title">{{ dialogTitle }}</h2>


<mat-dialog-content class="nta-dialog-content">
  <form [formGroup]="ntaForm">

    <div class="nta-form-grid">

      <!-- Diagnosis Name -->
      <mat-form-field appearance="outline" class="nta-form-field">
        <mat-label>Diagnosis Name</mat-label>
        <input matInput formControlName="diagnosisName" placeholder="Diagnosis Name" />
      </mat-form-field>

      <!-- ICD-10 Code -->
      <mat-form-field appearance="outline" class="nta-form-field">
        <mat-label>ICD-10 Code *</mat-label>
        <input type="text" matInput formControlName="icd10" [matAutocomplete]="auto"
               placeholder="Search by code or description">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                          (optionSelected)="onCodeSelected($event)">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            <strong>{{ option.code }}</strong> - {{ option.description }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="ntaForm.get('icd10')?.hasError('required')">
          ICD-10 code is required
        </mat-error>
      </mat-form-field>

      <!-- NTA Condition -->
      <mat-form-field appearance="outline" class="nta-form-field">
        <mat-label>NTA Condition</mat-label>
        <mat-select formControlName="ntaCondition">
          <mat-option *ngFor="let cond of ntaConditionOptions" [value]="cond">
            {{ cond }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Clinical Category -->
      <mat-form-field appearance="outline" class="nta-form-field">
        <mat-label>Clinical Category</mat-label>
        <mat-select formControlName="clinicalCategory">
          <mat-option *ngFor="let cat of clinicalCategoryOptions" [value]="cat.name">
            {{ cat.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Points -->
      <mat-form-field appearance="outline" class="nta-form-field">
        <mat-label>Points</mat-label>
        <input matInput type="number" formControlName="points" />
      </mat-form-field>

      <!-- Risk -->
      <mat-form-field appearance="outline" class="nta-form-field">
        <mat-label>Risk</mat-label>
        <mat-select formControlName="risk">
          <mat-option value="Low">Low</mat-option>
          <mat-option value="Medium">Medium</mat-option>
          <mat-option value="High">High</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Status -->
      <mat-form-field appearance="outline" class="nta-form-field">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let st of statusOptions" [value]="st.value">
            {{ st.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Include Checkbox -->
      <mat-checkbox formControlName="isInclude">Include</mat-checkbox>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()">{{ dialogSaveUpdate }}</button>
</mat-dialog-actions>
